import { useEffect, useState } from "react";

const statuses = [
  "Reviewing company data",
  "Analyzing last interaction",
  "Scanning recent activity logs",
  "Looking for related deals",
  "Filtering irrelevant data",
  "Reading through the current thread",
  "Exploring tagged connections",
  "Connecting related data points",
  "Refining key points",
  "Summarizing detected patterns",
];

const CHANGE_INTERVAL = 3000;

export function GenerationStatus() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Start from first status on mount
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % statuses.length);
    }, CHANGE_INTERVAL);

    return () => clearInterval(intervalId);
  }, []);

  return <span className="text-xs text-gray-550">{statuses[currentIndex] + "..."}</span>;
}
